import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { ArrowBigLeft } from 'lucide-react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAddTicketCategory } from '../api/supportapi';
import { WaitingLoader } from '../../../hooks/buttonLoad';

const schema = yup.object().shape({
    name: yup.string()
        .required('Category is required')
});

function AddTicketCategory() {
    const navigate = useNavigate();
    const { control, handleSubmit, formState: { errors }, } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
        }
    });

    const [loading, setLoading] = useState(false)
    const categoryMutation = useAddTicketCategory()

    const onSubmit = async (data) => {
        setLoading(true)
        await categoryMutation.mutateAsync({ name: data.name })
        setLoading(false)

    };


    const renderCategory = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', maxWidth: '500px', margin: 'auto' }}>

                <div className='mb-3'>
                    <label className="form-label" htmlFor="name">Category</label>
                    <Controller name='name' control={control} render={({ field }) => (
                        <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder='Enter Category'
                            autoComplete='off'
                        />
                    )} />
                    {errors.name && <p className="errMsg" style={{ color: "red" }}>* {errors.name.message}</p>}
                </div>

                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
            </form>
        </div>
    );

    return (
        <section>
            {loading && <WaitingLoader />}
            <h3>Add Category</h3>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-end align-items-center mb-2'>
                    <button
                        className='btn btn-primary d-flex align-items-center'
                        onClick={() => navigate("/ticket-category")}
                    >
                        <ArrowBigLeft size={20} style={{ marginRight: "2px" }} /> BACK
                    </button>
                </div>
                {renderCategory()}
            </div>
        </section>
    );
}

export default AddTicketCategory;